import { render } from "./PageSettings.vue?vue&type=template&id=47ce282a"
import script from "./PageSettings.vue?vue&type=script&lang=js"
export * from "./PageSettings.vue?vue&type=script&lang=js"

import "./PageSettings.vue?vue&type=style&index=0&id=47ce282a&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__